function initializeStats() {

  function onEntry(entry) {
    entry.forEach((change) => {
      if (change.isIntersecting) {
        change.target.classList.add('shown');
        statsObserver.unobserve(change.target);
        animateValue(change.target, 0, parseInt(change.target.attributes['data-count'].value), 1000);
      }
    });
  }

  function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start).toLocaleString();
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  // instantiate a new Intersection Observer
  let statsObserver = new IntersectionObserver(onEntry);

  // list of paragraphs
  let elements = document.querySelectorAll('.stats .stat-number .counter');

  // loop through all elements
  // pass each element to observe method

  for (let elm of elements) {
    statsObserver.observe(elm);
  }

}

document.addEventListener('DOMContentLoaded', (event) => {
  initializeStats();
});
